export default __webpack_public_path__ + "static/media/2-JJD.89865e82.png";